import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICommonAddressFormMeta {
    addressType: FormInputMeta;
    address: FormInputMeta;
    city: FormInputMeta;
    street: FormInputMeta;
    poBox: FormInputMeta;
    postalCode: FormInputMeta;
    state: FormInputMeta;
    firstPhone: FormInputMeta;
    secondPhone: FormInputMeta;
    fax: FormInputMeta;

    schema: any;
}

const commonAddressFormMeta = {} as ICommonAddressFormMeta;

commonAddressFormMeta.addressType = {
    name: "addressType",
    type: "select",
    label: "Type Adresse",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

commonAddressFormMeta.address = {
    name: "address",
    type: "textarea",
    label: "Adresse",
    placeholder: "Adresse",
    validation: yup.string(),
};

commonAddressFormMeta.city = {
    name: "city",
    type: "select",
    label: "Ville",
    placeholder: "Ville",
    validation: yup.string().required("Champ obligatoire !"),
};

commonAddressFormMeta.street = {
    name: "street",
    type: "text",
    label: "Rue",
    placeholder: "Rue",
    validation: yup.string(),
};

commonAddressFormMeta.poBox = {
    name: "poBox",
    type: "text",
    label: "Po Box",
    placeholder: "Po Box",
    validation: yup.string(),
};

commonAddressFormMeta.postalCode = {
    name: "postalCode",
    type: "text",
    label: "Code Postal",
    placeholder: "Code Postal",
    validation: yup.string(),
};

commonAddressFormMeta.state = {
    name: "state",
    type: "text",
    label: "Etat",
    placeholder: "Etat",
    validation: yup.string(),
};

commonAddressFormMeta.firstPhone = {
    name: "firstPhone",
    type: "text",
    label: "1st Téléphone",
    placeholder: "1st Téléphone",
    validation: yup.string(),
};

commonAddressFormMeta.secondPhone = {
    name: "secondPhone",
    type: "text",
    label: "2nd Téléphone",
    placeholder: "2nd Téléphone",
    validation: yup.string(),
};

commonAddressFormMeta.fax = {
    name: "fax",
    type: "text",
    label: "Fax",
    placeholder: "Fax",
    validation: yup.string(),
};


commonAddressFormMeta.schema = yup.object().shape(getValidationSchema(commonAddressFormMeta));

export default commonAddressFormMeta;